/// <amd-module name="Search/ExtensionStatus/Contracts" />

import { InstalledExtension, RequestedExtension } from "ExtensionManagement/ManagementHub/Contracts/ExtensionManagement"
import { PublishedExtension } from "ExtensionManagement/ManagementHub/Contracts/Gallery";

/**
* Contract for extension management data provider
*/
export interface ExtensionManagementDefaultServiceData {
    /**
    * Account token to use when communicating with the gallery
    */
    accountToken: string;
    /**
    * Extensions installed in the current context
    */
    installedExtensions: InstalledExtension[];
    /**
    * The list of full PublishedExtensions for all installed extensions in the current context
    */
    installedPublishedExtensions: PublishedExtension[];

    marketplaceUrl: string;
    /**
    * Requested extensions for the current context
    */
    requestedExtensions: RequestedExtension[];
    serverKey: string;
    /**
    * The list of private published extensions shared with the current collection
    */
    sharedExtensions: PublishedExtension[];
    /**
    * Extension management related Permissions for the current user
    */
    userPermissions: { [key: string]: boolean; };
}

export var TypeInfo = {
    ExtensionManagementDefaultServiceData: {
        fields: <any>null
    }
}

export module ExtensionManagementPermissionNames {
    /**
    * The permission to manage (add, update, delete) extensions
    */
    export var ManageExtensions = "manageExtensions";
    /**
    * The permission to manage security.
    */
    export var ManageSecurity = "manageSecurity";
}

export interface IExtensionMetadata {
    userHasManageExtensionPermission: boolean;

    userHasRequestedExtension: boolean;

    isExtensionDisabled: boolean;

    extensionMarketplaceUrl: string;

    extensionDetailUrl: string
}